module.exports = __webpack_public_path__ + "img/sw-ys12.f6e931e1.jpg";